module.exports = __webpack_public_path__ + "static/media/Red Cheerleader.c44cb72e.jpg";